import { render, staticRenderFns } from "./MobileUI.vue?vue&type=template&id=5c85fba4&"
import script from "./MobileUI.vue?vue&type=script&lang=js&"
export * from "./MobileUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports